module.exports = __webpack_public_path__ + "static/media/g-2.ca67636d.jpg";